<template>
  <div class="modeList" @click="detail">
    <div class="modeList-title">
      异动类别：{{ item.ydlb ? item.ydlb : "-" }}
    </div>
    <ul>
      <li class="modeList-item">
        <span>原班级:</span>
        <p>{{ item.ybj ? item.ybj : "-" }}</p>
      </li>
      <li class="modeList-item">
        <span>现班级:</span>
        <p>{{ item.xbj ? item.xbj : "-" }}</p>
      </li>
    </ul>
    <div class="modeList-textarea">
      <span>异动原因:</span>
      <p>{{ item.ydyy ? item.ydyy : "-" }}</p>
    </div>
    <!-- (0:未通过,1:通过,2:审核中,3:待审核)  -->
    <div
      :class="{
        'modeList-state': true,
        wtg: item.iswfmes == 0,
        ytg: item.iswfmes == 1,
        shz: item.iswfmes == 2,
        dsh: item.iswfmes == 3
      }"
    >
      {{ item.zszt ? item.zszt : "-" }}
    </div>
  </div>
</template>

<script>
export default {
  name: "modeList",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    detail() {
      this.$emit("detail", this.item);
    }
  }
};
</script>

<style lang="less" scoped>
.modeList {
  position: relative;
  background: #ffffff;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  .modeList-title {
    width: calc(~"100% - 70px");
    font-family: SourceHanSansCN-Medium;
    font-size: 16px;
    line-height: 16px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 13px;
  }
  .modeList-item {
    display: flex;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    line-height: 14px;
    color: #999999;
    letter-spacing: 0;
    font-weight: 400;
    span {
      white-space: nowrap;
    }
    p {
      white-space: wrap;
    }
    & + .modeList-item {
      margin-top: 8px;
    }
  }
  .modeList-textarea {
    margin-top: 11px;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 400;
    line-height: 30px;
    display: flex;
    background-image: linear-gradient(
      90deg,
      #f2f2f4 0%,
      rgba(242, 242, 244, 0) 100%
    );
    border-radius: 4px;
    padding: 0 10px;
  }
  .modeList-state {
    position: absolute;
    top: 0;
    right: 0;
    width: 56px;
    height: 24px;
    line-height: 24px;
    border-radius: 0 8px 0 8px;
    font-family: SourceHanSansCN-Regular;
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    &.shz {
      color: #ffa400;
      background: rgba(255, 164, 0, 0.15);
    }
    &.wtg {
      color: #f56c6c;
      background: rgba(245, 108, 108, 0.15);
    }
    &.ytg {
      color: #41b29c;
      background: rgba(65, 178, 156, 0.15);
    }
    &.dsh {
      color: #a2a2a2;
      background: rgba(162, 162, 162, 0.15);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/xjydsq/mode/modeList.vue